import React, { useState, useEffect } from 'react';
import { Dropdown, Button, Popup, Flex, Text, Datepicker } from '@fluentui/react-northstar';
import { FilterIcon } from '@fluentui/react-northstar';
import RevenueService from '../../../services/revenueservice';
import '../microsoftbilling/microsoftbilling.scss';
import { OPERATIONSTATUS } from '../../../shared/appcomponents/enums';

const DemoUserFilterDialog = ({ handleFilterUpdate, elegibleFilters, acquireToken, viewStatus, resetGridData }) => {
    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    };

    const getStartDate = () => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 1); // Subtract 1 year from today
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    };

    const [selectedFilters, setSelectedFilters] = useState({
        Product: "CX", // Set default product to "CX"        
        startDate: getStartDate(),
        endDate: getCurrentDate(),
    });

    const [tempFilters, setTempFilters] = useState({
        Product: "CX", // Set default product to "CX"  
        Customer:"",      
        startDate: getStartDate(),
        endDate: getCurrentDate(),
    });

    const [filterOptions, setFilterOptions] = useState({
        Product: [],
        Customer:[],
        startDate: getStartDate(),
        endDate: getCurrentDate(),
    });

    const [products, setProducts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);    
    const [defCusValue,setDefCusValue] = useState("");
    
    useEffect(() => {
        acquireToken((token) => {
            setLoading(true);
            RevenueService.GetDemoFilterOptions(token)
                .then(response => {
                    if (response) {
                        const mappedOptions = {
                            Product: response.Product.map(item => ({ key: item.key, text: item.text })),
                        };
                        setProducts(response.Product.map(item => item.text));
                        setFilterOptions(mappedOptions);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching filter options:', error);
                    setLoading(false);
                });
        });
    }, [acquireToken]);

    const handleDropdownChange = (filterType, event, data) => {
        setTempFilters(prevFilters => ({
            ...prevFilters,
            [filterType]: data.value || null // Set selected value
        }));      
        
        //alert(filterType);
    };
    const handleCustomerDropdownChange = (filterType, event, data) => {
        setTempFilters(prevFilters => ({
            ...prevFilters,
            [filterType]: data.value || null // Set selected value
        }));      
        setDefCusValue(data.value);
        //alert(filterType);
    };
    const handleProductDropdownChange = (filterType, event, data) => {
        setTempFilters(prevFilters => ({
            ...prevFilters,
            [filterType]: data.value || null // Set selected value
        }));
        
       //alert(data.value);

       acquireToken((token) => {
        setLoading(true);
       
        RevenueService.GetDemoCustomersByProduct(token,data.value)
            .then(response => {
                if (response) {
                    //const mappedOptions = {
                      //  Product: response.Product.map(item => ({ key: item.key, text: item.text })),
                    //};
                    setCustomers([]);                  
                    setDefCusValue("");
                    setCustomers(response.Customers.map(item => item.text));
                    //setFilterOptions(mappedOptions);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching filter options:', error);
                setLoading(false);
            });
    });

    };

    useEffect(() => {
        acquireToken((token) => {
        RevenueService.GetDemoCustomersByProduct(token,"CX")
            .then(response => {
                if (response) {
                    //const mappedOptions = {
                      //  Product: response.Product.map(item => ({ key: item.key, text: item.text })),
                    //};
                    setCustomers(response.Customers.map(item => item.text));
                    //setFilterOptions(mappedOptions);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching filter options:', error);
                setLoading(false);
            });   
        }); 
    }, []);

    useEffect(() => {
        if (isOpen) {
            setTempFilters({
                ...selectedFilters,
            });
        }
    }, [isOpen, selectedFilters]);

    const applyFilters = () => {
        const transformedData = {
            // Directly use tempFilters.Product; it will now be a string
            Product: tempFilters.Product, // no need to map or join
            Customer:defCusValue,
            StartDate: formatDateForSQL(tempFilters.startDate),
            EndDate: formatDateForSQL(tempFilters.endDate),
        };

        console.log('Applying filters with payload:', transformedData); // Debugging line

        setSelectedFilters(tempFilters); // Update selected filters state 
        handleFilterUpdate(transformedData); // Trigger filter update in parent
        setIsOpen(false); // Close dialog after applying filters
    };

    const closeDialog = () => {
        setIsOpen(false);
    };

    const formatDateForSQL = (date) => {
        if (!date) return null; // Ensure no date results in null
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const resetFilters = () => {
        const defaultFilters = {
            Product: "CX",            
            startDate: getStartDate(),
            endDate: getCurrentDate(),
        };

        setTempFilters(defaultFilters);
        setSelectedFilters(defaultFilters);
        acquireToken((token) => {
            setLoading(true);
           
            RevenueService.GetDemoCustomersByProduct(token,"CX")
                .then(response => {
                    if (response) {
                        //const mappedOptions = {
                          //  Product: response.Product.map(item => ({ key: item.key, text: item.text })),
                        //};
                        setCustomers([]);                  
                        setDefCusValue("");
                        setCustomers(response.Customers.map(item => item.text));
                        //setFilterOptions(mappedOptions);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching filter options:', error);
                    setLoading(false);
                });
        });
        // Notify parent to reset filters
        handleFilterUpdate({
            Product: "CX",            
            StartDate: formatDateForSQL(defaultFilters.startDate),
            EndDate: formatDateForSQL(defaultFilters.endDate),
        }); // Ensure this calls to fetch data with the default filters

        setIsOpen(false); // Close dialog afterward
    };

    return (
        <Flex gap="gap.smaller" vAlign="center" style={{ alignItems: 'center' }}>
            <Text content="Applied Filters:" weight="regular" />
            <Popup
                className="my-popup"
                open={isOpen}
                trigger={<Button style={{ boxShadow: 'none' }} className="pl-3 pr-3 filter-btn" circular icon={<FilterIcon />} content="Add Filter" onClick={() => setIsOpen(true)} />}
                content={
                    <Flex column gap="gap.smaller" style={{ width: '350px', maxHeight: '600px', overflowY: 'auto' }}>
                        {loading && <Text content="Loading filter options..." />}
                        {!loading && (
                            <>
                                {elegibleFilters.includes("Product") && (
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <Text content="Product" weight="semibold" style={{ minWidth: '130px' }} />
                                        <Dropdown
                                            fluid
                                            placeholder="Select Product"
                                            items={products}
                                            value={tempFilters.Product} // Bind to the single value
                                            onChange={(e, data) => handleProductDropdownChange("Product", e, data)}
                                            styles={{ minWidth: '200px' }}
                                        />
                                    </Flex>
                                )}
                                
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <Text content="Customer" weight="semibold" style={{ minWidth: '130px' }} />
                                        <Dropdown
                                            fluid
                                            placeholder="Select Customer"                                
                                            items={customers}
                                            //value={tempFilters.Customer}  
                                            value={defCusValue}                                            
                                            onChange={(e, data) => handleCustomerDropdownChange("Customer", e, data)}
                                            styles={{ minWidth: '200px' }}
                                        />
                                    </Flex>
                                
                                <Flex row gap="gap.smaller">
                                    <Text content="Start Date" weight="semibold" style={{ minWidth: '130px' }} />
                                    <Flex className="date-picker-field" gap="gap.small" vAlign="center">
                                        <Datepicker
                                            allowManualInput={false}
                                            placeholder="Select date"
                                            selectedDate={tempFilters.startDate ? new Date(tempFilters.startDate) : null}
                                            onDateChange={(e, data) => handleDropdownChange('startDate', e, data)}
                                        />
                                    </Flex>
                                </Flex>
                                <Flex row gap="gap.smaller">
                                    <Text content="End Date" weight="semibold" style={{ minWidth: '130px' }} />
                                    <Flex className="date-picker-field" gap="gap.small" vAlign="center">
                                        <Datepicker
                                            allowManualInput={false}
                                            placeholder="Select date"
                                            selectedDate={tempFilters.endDate ? new Date(tempFilters.endDate) : null}
                                            onDateChange={(e, data) => handleDropdownChange('endDate', e, data)}
                                        />
                                    </Flex>
                                </Flex>
                                <Flex gap="gap.large" justify="end" vAlign="center">
                                    <Button
                                        content="Reset"
                                        onClick={resetFilters}
                                    />
                                    <Button content="Cancel" onClick={closeDialog} />
                                    <Button primary content="Apply" onClick={applyFilters} />
                                </Flex>
                            </>
                        )}
                    </Flex>
                }
                on="click"
                modal
                closeOnOutsideClick
            />
        </Flex>
    );
};

export default DemoUserFilterDialog;